var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';

var selectors = {
  button: '[data-button-wishlist]',
  grid: '[grid-wishlist]',
};

// document.addEventListener('DOMContentLoaded', function () {
//     var wishlist_counter = getWishlist().length;
//     $('.wishlist-counter').html(wishlist_counter);
//     setTimeout(function(){
//     initButtons();
//     initGrid();
//     resetWishlist();
//   }, 2000);  
// });

document.addEventListener('DOMContentLoaded', function () {
    // Check if resetWishlist has already been called
    var resetFlag = localStorage.getItem('wishlistResetFlag');

    if (!resetFlag) {
        // Call resetWishlist() function
        resetWishlist();

        // Set flag to indicate that resetWishlist has been called
        localStorage.setItem('wishlistResetFlag', 'true');
    }

    // Other code...
    var wishlist_counter = getWishlist().length;
    $('.wishlist-counter').html(wishlist_counter);
    setTimeout(function(){
        initButtons();
        initGrid();
    }, 2000);  
});


document.addEventListener('shopify-wishlist:updated', function (event) {
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', function (event) {
 
});

document.addEventListener('shopify-wishlist:init-buttons', function (event) {
 
});

var setupGrid = function (grid) {

  var wishlist = getWishlist();
  var requests = wishlist.map(function (handle) {

    var productTileTemplateUrl = '/products/' + handle + '?view=card';   
    console.log("productTileTemplateUrl", productTileTemplateUrl);

    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
      
  });

  Promise.all(requests).then(function (responses) {

    var wishlistProductCards = responses.join('');

if (wishlistProductCards) {
    grid.innerHTML = wishlistProductCards;
} else {
    var wishlistTrElements = document.querySelectorAll(".wishlist_tr");
    wishlistTrElements.forEach(function(element) {
        element.classList.add("remove-text");
    });

    grid.innerHTML = "<h3 class='wishlist-error'>Your wishlist is empty! </h3>";
}

    
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();

    var event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist }
    });
    document.dispatchEvent(event);
  });
  
};
  // console.log("hyyyyyyy");
var setupButtons = function (buttons) {
 // console.log("buttons==", buttons);
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.log('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
        
    button.addEventListener('click', function () {
      //console.log("productHandle==", productHandle);
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      var wishlist = getWishlist().length;
      $('.wishlist-counter').html(wishlist);
      
    });
  });
};

var initGrid = function () {
  // console.log("whislpage");
  // console.log( selectors.grid );
  var grid = document.querySelector(selectors.grid) || false;
  // console.log("grid====",grid);
  if (grid) setupGrid(grid);
  // console.log("setupGrid-=-=--=-=-",setupGrid);
};

var initButtons = function () {  
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  
  var event = new CustomEvent('shopify-wishlist:init-buttons', {
   
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  var event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};




$(document).on("click", ".quick_view_wishlist_class", function(event) {
    const productHandle = $('.product_wish').val();
   // console.log("productHandle", productHandle);
    updateWishlist(productHandle);
    $(this).toggleClass("active");
    $('.product-handle-'+productHandle).toggleClass("active");
    var wishlist_counter = getWishlist().length;
    $('.wishlist-counter').html(wishlist_counter);
  
});

// $(document).on("click", ".related-products .product-wishlist", function(event) {
//     const productHandle = $(this).attr('data-handle');
//    // console.log("productHandle", productHandle);
//     updateWishlist(productHandle);
//     $(this).toggleClass("active");
//     $('.product-handle-'+productHandle).toggleClass("active");
  
// });

// $(".quick_view_wishlist_class").click(function(){
//   $(this).toggleClass("wish-active");
// })